import React, { useContext, useEffect } from "react";
import "./SlideShow.css";
import "./ResponsiveSlideShow.css";
import Rotate from "react-reveal/Rotate";
import Flip from "react-reveal/Flip";
import Fade from "react-reveal/Fade";
import Zoom from "react-reveal/Zoom";
import Bounce from "react-reveal/Bounce";
import Slide from "react-reveal/Slide";
import Jump from "react-reveal/Jump";
import LightSpeed from "react-reveal/LightSpeed";
import Roll from "react-reveal/Roll";
import { dataContext } from "../../context/DataContextProvider";
import { motion, Variants } from "framer-motion";
import Aos from "aos";

const textAnimate = {
  offscreen: { x: -200, opacity: 0 },
  onscreen: {
    x: 0,
    opacity: 1,
    // rotate: [0, -50, 0],
    transition: { type: "spring", bounce: 0.4, duration: 4 },
  },
};

const textAnimate2 = {
  offscreen: { x: -300, opacity: 0 },
  onscreen: {
    x: 0,
    // rotate: [0, 40, 0],
    opacity: 1,
    transition: { type: "spring", bounce: 0.4, duration: 1.5 },
  },
};

const textAnimate3 = {
  offscreen: { x: -300, opacity: 0 },
  onscreen: {
    x: 0,
    // rotate: [0, -60, 0],
    opacity: 1,
    transition: { type: "spring", bounce: 0.4, duration: 1.5 },
  },
};

const SlideShow = () => {
  const { allWebParts } = useContext(dataContext);
  useEffect(() => {
    Aos.init();
  }, []);

  const filterAllWebParts = allWebParts?.filter(
    (x) => x.uniqueName === "slideshow"
  );

  const filetrKeySlideShow = (key) => {
    if (filterAllWebParts) {
      const result = JSON.parse(filterAllWebParts[0]?.specification)?.filter(
        (item) => {
          return item.Key === key;
        }
      );
      return result;
    }
  };

  return (
    <main className="slide-show">
      <div className="content">
        <div className="section-container d-flex  p-0">
          <div className="left-section">
            <motion.div
              className="left-section-content"
              initial={"offscreen"}
              whileInView={"onscreen"}
              viewport={{ once: false, amount: 1 }}
              transition={{ staggerChildren: 1.5 }}
            >
              <motion.h1 variants={textAnimate}>
                {filetrKeySlideShow("slideshow-title") &&
                  filetrKeySlideShow("slideshow-title")[0].Value}
              </motion.h1>
              <motion.p variants={textAnimate2} className="p-slide">
                {filetrKeySlideShow("slideshow-paragraph1") &&
                  filetrKeySlideShow("slideshow-paragraph1")[0].Value}
              </motion.p>
              <motion.p variants={textAnimate3} className="p-slide">
                {filetrKeySlideShow("slideshow-paragraph2") &&
                  filetrKeySlideShow("slideshow-paragraph2")[0].Value}
              </motion.p>
            </motion.div>
          </div>
          <div className="right-section">
            <Fade>
              <Zoom>
                <Slide right cascade duration={2000}>
                  <picture>
                    <source
                      srcSet="/pic/Choco.png"
                      media="(min-width: 1200px)"
                    />
                    <img
                      src={filetrKeySlideShow("slideshow-image")?.map(
                        (item) => item.Value
                      )}
                      alt="slider-img"
                      className="slider-img"
                    />
                  </picture>
                </Slide>
              </Zoom>
            </Fade>
          </div>
          {/* 
          <div className="tablet-text">
            <Zoom right cascade>
              <p className="">
                {filetrKeySlideShow("slideshow-paragraph1") &&
                  filetrKeySlideShow("slideshow-paragraph1")[0].Value}
              </p>
            </Zoom>
            <Zoom left cascade>
              <p className="">
                {filetrKeySlideShow("slideshow-paragraph2") &&
                  filetrKeySlideShow("slideshow-paragraph2")[0].Value}
              </p>
            </Zoom>
          </div> */}

          <motion.div
            className="tablet-text"
            initial={"offscreen"}
            whileInView={"onscreen"}
            viewport={{ once: false, amount: 1 }}
            transition={{ staggerChildren: 1.5 }}
          >
            <motion.p variants={textAnimate2}>
              {filetrKeySlideShow("slideshow-paragraph1") &&
                filetrKeySlideShow("slideshow-paragraph1")[0].Value}
            </motion.p>
            <motion.p variants={textAnimate3}>
              {filetrKeySlideShow("slideshow-paragraph2") &&
                filetrKeySlideShow("slideshow-paragraph2")[0].Value}
            </motion.p>
          </motion.div>
        </div>
      </div>
      <div className="shape-container position-relative w-100">
        <img src="/pic/Shape.png" alt="main-img" className="shape-img" />
      </div>
    </main>
  );
};

export default SlideShow;
